import { render, staticRenderFns } from "./StarSelectInput.vue?vue&type=template&id=085291d5&scoped=true&"
import script from "./StarSelectInput.vue?vue&type=script&lang=js&"
export * from "./StarSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./StarSelectInput.vue?vue&type=style&index=0&id=085291d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085291d5",
  null
  
)

export default component.exports